import React from 'react'
import styles from './styles.css'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import MdCheck from 'react-icons/lib/md/check'
import MdClear from 'react-icons/lib/md/clear'
import moment from 'moment'
import Layout from './Layout'
import UserOrganizations from './UserOrganizations'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import { Form, Field } from 'simple-react-form'
import Toggle from 'orionsoft-parts/lib/components/fields/Toggle'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import Button from 'orionsoft-parts/lib/components/Button'

@withGraphQL(gql`
  query user($_id: ID!) {
    user(_id: $_id) {
      _id
      hasTwoFactor
      emails {
        address
        verified
      }
      createdAt
      profile {
        name
        phone
      }
      active
      documents
      sign
      pending
      mySign
      view
      archive
      templates
      services {
        domain
      }
    }
  }
`)
@withMutation(gql`
  mutation setUserActive($userId: ID!, $active: Boolean!) {
    setUserActive(userId: $userId, active: $active) {
      _id
      active
    }
  }
`)
@withMutation(gql`
  mutation blockUser($userId: ID!) {
    blockUser(userId: $userId){
      success
    }
  }
`)
@withMutation(gql`
  mutation resetFailedLogins($userId: ID!) {
    resetFailedLogins(userId: $userId){
      success
    }
  }
`)
@withMutation(gql`
  mutation setUserPlan($userId: ID!, $planId: ID!) {
    setUserPlan(userId: $userId, planId: $planId) {
      success
    }
  }
`)
@withMutation(gql`
  mutation addSignaturesPack($userId: ID!, $packId: ID!) {
    addSignaturesPack(userId: $userId, packId: $packId) {
      success
    }
  }
`)

@withGraphQL(gql`
  query userSignaturesPacks4Admin($_id: ID) {
    userSignaturesPacks4Admin(userId: $_id) {
        _id
        initDate
        signaturePack {
          name
          simpleSignatures
          advancedSignatures
        }
        simpleSignatures {
          documentId
          signatureId
        }
        advancedSignatures {
          signatureId
        }
    }
  }
`)
@withGraphQL(gql`
  query userPlan($_id: ID) {
    userPlan(userId: $_id)  {
      initDate
      endDate
      period {
        initDate
        endDate
        simpleSignatures {
          documentId
          signatureId
        }
        advancedSignatures {
          documentId
        }
      }
      plan {
        _id
        name
        simpleSignatures
        advancedSignatures
      }
    }
  }
`)

@withGraphQL(gql`
  query plans {
    plans {
        _id
        name
        simpleSignatures
        advancedSignatures
    }
  }
`)
@withGraphQL(gql`
  query signaturesPacks4Admin {
    signaturesPacks4Admin {
        _id
        name
        
    }
  }
`)

@withMutation(gql`
  mutation disableTwoFactor($userId: ID!) {
    disableTwoFactor(userId: $userId) {
      success
    }
  }
`)


@withMessage
export default class UserInformation extends React.Component {
  static propTypes = {
    setUserActive: PropTypes.func,
    userSignaturesPacks4Admin: PropTypes.object,
    userPlan: PropTypes.object,
    showMessage: PropTypes.func,
    user: PropTypes.object,
    params: PropTypes.object,
    plans: PropTypes.array,
    signaturesPacks4Admin: PropTypes.array,
    onChange: PropTypes.func,
    resetFailedLogins: PropTypes.func,
    blockUser: PropTypes.func,
    disableTwoFactor: PropTypes.func
  }

  state = {
    packAgregado : ""
  }

  async changePlan(planId){
    
    await this.props.setUserPlan({
      userId: this.props.user._id,
      planId: planId
    },
    {
      refetchQueries: ['userPlan']
    })
    this.state.packAgregado = ""
  }

  async addPack(packId){
    await this.props.addSignaturesPack({
      userId: this.props.user._id,
      packId: packId
    },
    {
      refetchQueries: ['userSignaturesPacks4Admin']
    })
  }

  renderProfile() {
    return (
      <div className={styles.profile}>
        <div className="row">
          <div className="col-xs-6 col-sm-1">
            <b>Perfil</b>
          </div>
          <div className="col-xs-6 col-sm-10">
            {this.props.user.profile.name || 'Sin nombre definido'}
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6 col-sm-1" />
          <div className="col-xs-6 col-sm-10">
            {this.props.user.profile.phone || 'Sin telefono definido'}
          </div>
        </div>
      </div>
    )
  }

  renderEmails() {
    return (
      <div className={styles.emails}>
        <div className="row">
          <div className="col-xs-12 col-sm-1">
            <b>Emails</b>
          </div>
          <div className="col-xs-12 col-sm-10">
            {this.props.user.emails.map((email, index) => {
              return (
                <div key={index}>
                  <div className="row">
                    <div className="col-xs-12 col-sm-5">{email.address}</div>
                    <div className="col-xs-12 col-sm-7">
                      Verified{' '}
                      {email.verified ? (
                        <MdCheck size={20} style={{ color: '#3cb371' }} />
                      ) : (
                        <MdClear size={20} style={{ color: 'red' }} />
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  renderId() {
    return (
      <div className={styles.id}>
        <div className="row">
          <div className="col-xs-12 col-sm-1">
            <b>userId</b>
          </div>
          <div className="col-xs-12 col-sm-10">{this.props.user._id}</div>
        </div>
      </div>
    )
  }

  renderDomain() {
    return (
      <div className={styles.id}>
        <div className="row">
          <div className="col-xs-12 col-sm-1">
            <b>Dominio</b>
          </div>
          <div className="col-xs-12 col-sm-10">{this.props.user.services.domain}</div>
        </div>
      </div>
    )
  }

  renderCreatedAt() {
    return (
      <div className={styles.created}>
        <div className="row">
          <div className="col-xs-12 col-sm-1">
            <b>Creado</b>
          </div>
          <div className="col-xs-12 col-sm-10">
            <div className="row">
              <div className="col-xs-12 col-sm-5">
                {moment(this.props.user.createdAt).format('DD/MM/YYYY HH:mm')}
              </div>
              <div className="col-xs-12 col-sm-7">
                Activado{' '}
                {this.props.user.active ? (
                  <MdCheck size={20} style={{ color: '#3cb371' }} />
                ) : (
                  <MdClear size={20} style={{ color: 'red' }} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderSetActive() {
    return (
      <Form
        ref={form => {
          this.form = form
        }}
        state={this.props.user}
        onChange={async form => {
          await this.props.setUserActive({
            userId: this.props.user._id,
            active: form.active
          })
          this.props.showMessage('Usuario actualizado')
        }}
      >
        <div className={styles.setActive}>
          <div className="row">
            <div className="col-xs-12 col-sm-3">
              <b>Usuario activado</b>
            </div>
            <div className="col-xs-12 col-sm-7">
              <Field fieldName="active" type={Toggle} />
            </div>
          </div>
        </div>
      </Form>
    )
  }

  renderListaPaquetes(packsDeFirmas){
    console.log("usp: " + packsDeFirmas )
    return packsDeFirmas.map( packDeFirmas => {
      if(packDeFirmas.signaturePack){
        let firmasSimples = packDeFirmas.signaturePack.simpleSignatures
        let firmasAvanzadas = packDeFirmas.signaturePack.advancedSignatures
        let simplesUsadas = packDeFirmas.simpleSignatures? packDeFirmas.simpleSignatures.length : 0;
        let avanzadasUsadas = packDeFirmas.advancedSignatures? packDeFirmas.advancedSignatures.length : 0;
        return (
          <tr style={{ cursor: 'pointer' }}>
            <td>{packDeFirmas.signaturePack.name}</td>
            <td>{this.formatFecha(packDeFirmas.initDate)}</td>
            <td>{this.formatFecha(packDeFirmas.endDate)}</td>
            <td>{ simplesUsadas + " / " + firmasSimples }</td>
            <td>{ avanzadasUsadas + " / " + firmasAvanzadas }</td>
          </tr>
        )
      } else {
        return null;
      }
    })
}

  renderListadoPaqueteDeFirmas(){
    if(this.props.userSignaturesPacks4Admin && this.props.userSignaturesPacks4Admin.length > 0){
      return (
        <div className="paginated-table table hoverable">
          <table>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Fecha Compra</th>
                <th>Disponibles Hasta</th>
                <th>Simples</th>
                <th>Avanzadas</th>
              </tr>
            </thead>
            <tbody>
              { this.renderListaPaquetes(this.props.userSignaturesPacks4Admin) }                            
            </tbody>
          </table>
        </div>
      )
    } else {
      return (
        <div className={styles.noTable}><p>Usted no tiene paquetes de firma disponibles</p></div>
      )
    }
  }
  
  formatFecha(fechaInt) {
    if(!fechaInt)
      return " - "
    return moment(fechaInt).format('DD/MM/YYYY')
  }

  renderPackOptions() {
    if (!this.props.signaturesPacks4Admin) return
    return this.props.signaturesPacks4Admin.map(pack => {
      return <option key={pack.name} value={pack._id}>{pack.name}</option>
    })
  }

  renderOptions () {
    if (!this.props.plans) return
    return this.props.plans.map(plan => {
      return <option key={plan.name} value={plan._id}>{plan.name}</option>
    })
  }

  renderPlanData(){
    if(this.props.userPlan)
      return(
        <div className={styles.container}>
          <div className="content">
            <span className="col-xs-6 col-sm-6"><b>Plan: </b></span>   

            <select 
              className="col-xs-6 col-sm-6"
              value={this.props.userPlan.plan._id} 
              onChange={event => this.changePlan(event.target.value)}>
              {this.renderOptions()}
            </select>

            <p>Periodo entre { this.formatFecha(this.props.userPlan.period.initDate) } y { this.formatFecha(this.props.userPlan.period.endDate) }</p>
              <div className="label">Firmas Simples del Periodo { this.props.userPlan.period.simpleSignatures.length + ' / ' + this.props.userPlan.plan.simpleSignatures }</div>
              <div className="label">Firmas Avanzadas del Periodo { this.props.userPlan.period.advancedSignatures.length + ' / ' + this.props.userPlan.plan.advancedSignatures } </div>
              <br />
                <div className="section">
                    <div className="header">
                      <h1 className={styles.noTable}>Paquetes de Firmas Disponibles</h1>
                    </div>
                    {this.renderListadoPaqueteDeFirmas()}
                </div>
                <p>
                  <span>Agregar Pack: </span>
                  <select 
                      className="col-xs-6 col-sm-6"
                      value={this.state.packAgregado}
                      onChange={event => this.addPack(event.target.value)}>
                      <option value="">Seleccione pack de firmas para Agregar</option>
                      {this.renderPackOptions()}
                  </select>
                </p>
          </div>
        </div>
    )
  }

  renderEnableButtons(){
    return (
      <div className="row">
          <div className="col-xs-3 col-sm-3">
            <Button className={styles.btnBlock} onClick={async form => {
              await this.props.blockUser({
                userId: this.props.user._id
              })
              this.props.showMessage('Usuario bloqueado')
            }}>Bloquear usuario</Button>
          </div>
          <div className="col-xs-3 col-sm-3">
            <Button primary onClick={async form => {
              await this.props.resetFailedLogins({
                userId: this.props.user._id
              })
              this.props.showMessage('Usuario DES bloqueado')
            }}>Desbloquear usuario</Button>
          </div>
      </div>
      
    )
  }

  renderDisableTwoFactor(){
    console.log('This user ----> ', this.props.user)

    const twoFactor = this.props.user.hasTwoFactor
    if(twoFactor === false || twoFactor === null ){
      return (
        <div className="row">
            <div className="col-xs-3 col-sm-3">
              <Button className={styles.btnDisable} disabled onClick={async form => {
                await this.props.disableTwoFactor({userId: this.props.user._id})
                this.props.showMessage('Sin TwoFactor')
              }}>Quitar TwoFactor</Button>
            </div>
        </div>
      )
    }
      return (
        <div className="row">
            <div className="col-xs-3 col-sm-3">
              <Button className={styles.btnQuit} onClick={async form => {
                await this.props.disableTwoFactor({userId: this.props.user._id})
                this.props.showMessage('Sin TwoFactor')
              }}>Quitar TwoFactor</Button>
            </div>
        </div>

    
      
    )
  }

  render() {
    if (!this.props.user) return
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3 className={styles.title}>
              Usuario: {this.props.user.emails[0].address}
            </h3>
          </div>
          <div className="content" style={{ backgroundColor: 'white' }}>
            {this.renderProfile()}
            <br />
            {this.renderId()}
            <br />
            {this.renderEmails()}
            <br />
            {this.renderCreatedAt()}
            <br />
            {this.renderSetActive()}
            <br />
            {this.renderEnableButtons()}
            <br />
            {this.renderDisableTwoFactor()}
            <br />
            {this.renderDomain()}
            <br />
            {this.renderPlanData()}
          </div>
        </div>
        <Layout user={this.props.user} userId={this.props.user._id} />
        <UserOrganizations userId={this.props.user._id} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Admin/UserInformation/index.js